// extracted by mini-css-extract-plugin
export default {"container":"kPHbT","svgContainer":"_4kGOw"};